import { render, staticRenderFns } from "./SchoolEventCard.vue?vue&type=template&id=a2a08e16&scoped=true&"
import script from "./SchoolEventCard.vue?vue&type=script&lang=ts&"
export * from "./SchoolEventCard.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolEventCard.vue?vue&type=style&index=0&id=a2a08e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a08e16",
  null
  
)

export default component.exports